import { ListContainer } from './styles';

const List = ({ ordered = false, listStyleType, children, ref, ...flexProps }) => {
	return (
		<ListContainer ref={ref} $ordered={ordered} $listStyleType={listStyleType} {...flexProps}>
			{children}
		</ListContainer>
	);
};

List.displayName = 'List';

export default List;
